const aiGymTrainer = {
  id: 6,
  slug: "ai-gym-trainer",

  title: "AI Gym Trainer & Diet Planner",

  description:
    "An AI-powered fitness application that delivers personalized workout plans, intelligent diet recommendations, progress tracking, and health analytics to help users achieve their fitness goals.",

  category: "AI & Machine Learning",
  type: "Product",
  status: "Completed",
  year: "2026",

  timeline: "6 Months",

  developedBy: "Horyzen Technologies",

  role: "Full Stack Mobile & AI Development",

  technologies: [
    "Flutter",
    "Python",
    "TensorFlow",
    "Firebase",
    "Cloud Firestore",
    "Node.js",
    "REST API"
  ],

  image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "",
  githubUrl: "",

  featured: true
};

export default aiGymTrainer;